import { Injectable, inject } from '@angular/core';
import { RememberStateService } from './remember-state.service';

@Injectable({
    providedIn: 'root'
})
export class DarkModeService {
    private rememberStateService = inject(RememberStateService);

    private isDarkMode: boolean;

    constructor() {
        // Initialize the dark mode state from the remember state service
        this.set(this.rememberStateService.get('darkMode') ?? false);
    }

    set(isEnabled: boolean): void {
        this.isDarkMode = isEnabled;
        if (isEnabled) {
            document.documentElement.classList.add('dark');
        } else {
            document.documentElement.classList.remove('dark');
        }
        // Save the state in remember state service
        this.rememberStateService.set('darkMode', isEnabled);
    }

    toggle(): void {
        this.set(!this.isDarkMode);
    }

    get(): boolean {
        return this.isDarkMode;
    }
}
